<template>
  <div class="audit-page">
    <my-title />

    <div class="search-form clearfix">
      <a-input
        v-model="form.keyword1"
        class="fl"
        :placeholder="keyword1Placeholder"
        @keyup.enter="onSearch(form.keyword1)"
      />
      <span class="fl">{{ $t('message["451"]') }}</span>
      <a-input
        v-model="form.keyword2"
        class="fl"
        :placeholder="contactTit"
        @keyup.enter="onSearch(form.keyword2)"
      />
      <span class="fl">{{ $t('message["451"]') }}</span>
      <a-input
        v-model="form.keyword3"
        class="fl"
        :placeholder="mobileTit"
        @keyup.enter="onSearch(form.keyword3)"
      />
      <div class="btns fl clearfix">
        <a-button
          type="primary"
          class="fl"
          @click="onSearch"
        >
          {{ $t('message["91"]') }}
        </a-button>
        <a-button
          class="fl"
          @click="onReset"
        >
          {{ $t('message["1625"]') }}
        </a-button>
      </div>
    </div>
    <my-table
      ref="auditTable"
      :status="selected"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MyTitle from '@/components/pc/Title'
import MyTable from './Table'

export default {
  components: {
    MyTitle,
    MyTable
  },
  data () {
    return {
      selected: 0,
      tabLabels: [{
        key: 0,
        label: this.$t('message["143"]')
      }, {
        key: 1,
        label: this.$t('message["1464"]')
      }],
      form: {
        keyword1: '',
        keyword2: '',
        keyword3: ''
      }
    }
  },
  computed: {
    ...mapGetters('inquery/auditData', ['keyword1Placeholder']),
    contactTit () {
      return this.$t('message["605"]')
    },
    mobileTit () {
      return this.$t('message["1116"]')
    }
  },
  methods: {
    /* handleChangeTab (k) {
      this.selected = k
      document.documentElement.scrollTop = 0
      this.$router.push({
        query: {
          tab: k
        }
      })
    }, */
    onSearch (value) {
      if (!value) return
      // 如果数据都为空，不查询
      if (!this.form.keyword1 && !this.form.keyword2 && !this.form.keyword3) return

      this.$router.push({
        query: {
          ...this.$route.query,
          keywords: encodeURIComponent(JSON.stringify(this.form)),
          limit: 10,
          page: 1
        }
      })
      this.$refs.auditTable.getAuditList()
    },
    onReset () {
      this.form.keyword1 = ''
      this.form.keyword2 = ''
      this.form.keyword3 = ''

      this.$router.push({
        query: {
          ...this.$route.query,
          keywords: encodeURIComponent(JSON.stringify(this.form)),
          limit: 10,
          page: 1,
          sort: 1
        }
      })
      this.$refs.auditTable.getAuditList()
    }
  }
}
</script>

<style lang="scss" scoped>
.audit-page {
  overflow: hidden;
}

.search-form ::v-deep {
  > span {
    height: 32px;
    line-height: 32px;
    margin: 0 8px;
  }
  .ant-input {
    width: 240px;
  }
  .btns {
    margin-left: 16px;
  }
}
/* @media screen and (max-width: 1185px) {
  .search-form {
    .btns {
      float: right;
      margin-top: 12px;
    }
  }
}
@media screen and (max-width: 1025px) {
  .search-form {
    .ant-input,
    > span {
      margin-bottom: 12px;
    }
    .btns {
      float: left;
      margin-bottom: 12px;
      margin-top: 0;
    }
  }
} */
</style>
